// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/font-awesome/css/font-awesome.min.css
// module id = 302
// module chunks = 0